import { FaAdversal } from "react-icons/fa";
import { SiBrandfetch } from "react-icons/si";
import { RiLineChartLine, RiUser3Line, RiAwardLine, RiCheckboxCircleLine } from "react-icons/ri";
import { FiBarChart2, FiSearch, FiMessageCircle, FiMail, FiGlobe, FiBookOpen, FiEdit3, FiTrendingUp, FiTarget, FiCpu, FiMessageSquare } from "react-icons/fi";
import { LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCpu, LuMegaphone, LuPalette, LuRocket, LuShoppingBag, LuSmartphone, LuUsers, LuWallet } from "react-icons/lu";

export const MarketingHeroData = {
  backgroundImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
  subTitle: "Digital Marketing Services",
  title: (
    <>
      Amplify Your <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Digital Presence</span>
    </>
  ),
  description:
    "We help businesses grow online with data-driven digital marketing strategies focused on visibility, customer engagement, and lead generation. Our team creates performance-focused campaigns that improve search rankings, increase website traffic, and help brands build a stronger digital presence across search engines, social media platforms, and paid advertising channels. Trusted by startups, local businesses, and growing brands, our digital marketing solutions combine SEO expertise, performance marketing, content strategy, and audience analytics to deliver measurable business growth.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Better Search Visibility",
      desc: "Improve rankings, organic traffic, and online discoverability.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Targeted Marketing Campaigns",
      desc: "Reach the right audience with data-driven campaigns.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Consistent Brand Growth",
      desc: "Increase engagement, trust, and customer retention.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Performance-Focused Strategy",
      desc: "Drive qualified leads, conversions, and measurable ROI.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const marketingServices = [
  {
    icon: <FiBarChart2 size={40} color="#a855f7" />,
    title: "Growth Analytics & AI",
    description: "Data-driven marketing powered by machine learning. We track, analyze, and optimize every campaign for maximum ROI.",
    image: "/images/digitalMarketing/Growth_Marketing.webp",
    link: "/growth-analytics-ai-services-india",
    points: ["Marketing Performance Tracking", "Audience & Traffic Analytics", "ROI-Focused Optimization"],
  },
  {
    icon: <FiSearch size={40} color="#34d399" />,
    title: "SEO & Content Strategy",
    description: "Dominate search rankings with technical SEO, keyword research, and high-converting content that builds organic traffic.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/seo-content-strategy-services-india",
    points: ["Keyword Research & SEO", "Keyword Research & SEO", "Organic Traffic Growth"],
  },
  {
    icon: <FiMessageCircle size={40} color="#f59e0b" />,
    title: "Social Media Marketing",
    description: "Targeted campaigns across Twitter, Instagram, LinkedIn, TikTok, and emerging platforms that drive engagement and conversions.",
    image: "/images/digitalMarketing/social_media_marketing.webp",
    link: "/social-media-marketing-services-india",
    points: ["Social Media Campaigns", "Audience Engagement Strategy", "Platform Growth Optimization"],
  },
  {
    icon: <FiMail size={40} color="#22d3ee" />,
    title: "Email & Automation",
    description: "Automated drip campaigns, personalized sequences, and newsletter strategies that nurture leads into loyal customers.",
    image: "/images/digitalMarketing/Email_and_Automation.webp",
    link: "/email-automation-services-india",
    points: ["Email Campaign Management", "Lead Nurturing Automation", "Customer Retention Strategy"],
  },
  {
    icon: <FiGlobe size={40} color="#a855f7" />,
    title: "Web3 Community Building",
    description: "Discord & Telegram growth, DAO governance, token launch campaigns, and ambassador programs for crypto projects.",
    image: "/images/digitalMarketing/Web3_Community_Building.webp",
    link: "/web3-community-building-services-india",
    points: ["Discord & Telegram Growth", "Community Engagement", "Web3 Campaign Strategy"],
  },
  {
    icon: <FiBookOpen size={40} color="#34d399" />,
    title: "PPC & Paid Advertising",
    description: "Google Ads, Meta Ads, programmatic display, and retargeting campaigns optimized for cost-per-acquisition.",
    image: "/images/digitalMarketing/PPC_and_Paid_Advertising.webp",
    link: "/ppc-paid-advertising-services-india",
    points: ["Google & Meta Ads", "Retargeting Campaigns", "Performance Ad Optimization"],
  },
  {
    icon: <SiBrandfetch size={40} color="#3b82f6" />,
    title: "Branding Services",
    description: "Create a powerful brand identity that builds trust, recognition, and long-term customer loyalty.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/branding-services-india",
    points: ["Visual Identity Systems", "Brand Messaging", "Brand Guidelines"],
  },
  {
    icon: <FiTarget size={40} color="#8b5cf6" />,
    title: "Brand Strategy & Positioning",
    description: "Develop a clear brand strategy and market position that differentiates your business from competitors.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/brand-strategy-positioning-services-india",
    points: ["Brand Identity Development", "Market Positioning Strategy", "Customer Perception Analysis"],
  },
  {
    icon: <LuMegaphone size={40} color="#ec4899" />,
    title: "Brand Positioning & Promotion",
    description: "Strengthen your market presence through strategic positioning, promotion, and audience engagement initiatives.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/brand-positioning-promotion-services-india",
    points: ["Market Positioning Strategy", "Competitor Analysis", "Go-To-Market Planning"],
  },
  {
    icon: <FiEdit3 size={40} color="#f97316" />,
    title: "Content Marketing Services",
    description: "Attract, engage, and convert your audience with high-quality content tailored to every stage of the customer journey.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/content-marketing-services-india",
    points: ["Content Strategy", "Blog & Article Creation", "Lead Generation Content"],
  },
  {
    icon: <FiTrendingUp size={40} color="#10b981" />,
    title: "Organic Growth Content Marketing",
    description: "Increase organic visibility and sustainable traffic through SEO-driven content and audience-focused publishing.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/organic-growth-content-marketing-services-india",
    points: ["SEO Content Strategy", "Organic Traffic Growth", "Content Optimization"],
  },
  {
    icon: <FaAdversal size={40} color="#ef4444" />,
    title: "Ad Campaign Management",
    description: "Plan, launch, monitor, and optimize advertising campaigns across multiple channels to maximize performance.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/ad-campaign-management-services-india",
    points: ["Campaign Planning", "Audience Targeting", "Performance Tracking"],
  },
  {
    icon: <FiBarChart2 size={40} color="#6366f1" />,
    title: "Performance Marketing & Paid Media",
    description: "Scale business growth with data-driven paid media strategies focused on measurable conversions and revenue.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/performance-marketing-paid-media-services-india",
    points: ["Paid Media Strategy", "Conversion Optimization", "ROI-Focused Campaigns"],
  },
  {
    icon: <FiCpu size={40} color="#6366f1" />,
    title: "Generative Engine Optimization (GEO)",
    description:
      "Boost your brand's visibility in AI-generated answers across ChatGPT, Gemini, Perplexity, and Google AI Overviews with structured, citation-ready content strategies.",
    image: "/images/digitalMarketing/Generative_Engine_Optimization.webp",
    link: "/generative-engine-optimization-services-india",
    points: ["AI Search Visibility", "LLM Content Optimization", "AI Overview Ranking"],
  },
  {
    icon: <FiMessageSquare size={40} color="#6366f1" />,
    title: "Answer Engine Optimization (AEO)",
    description:
      "Position your brand as the trusted answer across voice assistants, featured snippets, and AI-powered Q&A platforms by optimizing content for direct, extractable answers.",
    image: "/images/digitalMarketing/Answer_Engine_Optimization.webp",
    link: "/answer-engine-optimization-services-india",
    points: ["Featured Snippet Optimization", "Voice Search Readiness", "Direct Answer Targeting"],
  },
  {
    icon: <FiTarget size={40} color="#34d399" />,
    title: "ChatGPT Ads Services",
    description:
      "Reach relevant audiences within ChatGPT advertising experiences with strategic campaign planning, contextual targeting, and conversion optimization.",
    image: "/images/digitalMarketing/Digital_Marketing.webp",
    link: "/chatgpt-advertising-services-india",
    points: ["Contextual Audience Targeting", "ChatGPT Campaign Management", "Conversion-Focused Growth"],
  },
];

export const MarketingProcessSteps = [
  {
    step: "01",
    title: "Discovery",
    description: "Deep-dive into your brand, audience, and competitive landscape.",
    points: ["Audience research", "Competitor analysis", "Goal alignment"],
  },
  {
    step: "02",
    title: "Strategy",
    description: "Custom marketing blueprint with KPIs, channels, and timelines.",
    points: ["Channel planning", "KPI definition", "Content roadmap"],
  },
  {
    step: "03",
    title: "Execution",
    description: "Launch campaigns with precision targeting and A/B testing.",
    points: ["Campaign launch", "A/B testing", "Performance tracking"],
  },
  {
    step: "04",
    title: "Optimize",
    description: "Continuous data analysis and iteration for peak performance.",
    points: ["Analytics review", "Optimization", "Scaling campaigns"],
  },
];

export const marketingFaqData = [
  {
    q: "What do digital marketing services in India include?",
    a: "Digital marketing services in India cover SEO, social media marketing, pay-per-click advertising, email campaigns, content marketing, and analytics tracking. These services help businesses improve online visibility, drive traffic, and boost conversions.",
  },
  {
    q: "How do I choose the best digital marketing agency for my business?",
    a: "Look for an agency with proven results, positive client reviews, a strong portfolio, and expertise in multiple digital marketing channels. The best agencies also provide customized strategies and ongoing support to help your business grow online.",
  },
  {
    q: "Do you work with small businesses or only large brands?",
    a: "We work with both. Our strategies are customized according to your budget, industry, and growth stage.",
  },
  {
    q: "How do you measure success?",
    a: "We track ROI, ROAS, Cost per Lead, Conversion Rate, Organic Traffic Growth, and revenue attributed to marketing using Google Analytics 4 and custom dashboards.",
  },
  {
    q: "Can you handle marketing only for a specific service like SEO or PPC?",
    a: "Yes. You can choose individual services or go for our full-spectrum digital marketing retainer.",
  },
];

export const marketingBenefits = [
  {
    icon: <RiLineChartLine className="w-7 h-7" />,
    title: "Data-Driven Results",
    desc: "Every campaign is backed by Google Analytics 4, Looker Studio & real-time insights for maximum ROI.",
  },
  {
    icon: <RiUser3Line className="w-7 h-7" />,
    title: "Full-Funnel Strategy",
    desc: "From awareness to retention — we handle the complete customer journey across all channels.",
  },
  {
    icon: <RiAwardLine className="w-7 h-7" />,
    title: "Proven Track Record",
    desc: "Helped 100+ businesses achieve 3x–8x growth in traffic, leads & revenue.",
  },
  {
    icon: <RiCheckboxCircleLine className="w-7 h-7" />,
    title: "Transparent Reporting",
    desc: "Monthly strategy calls + custom dashboards. No black box — you always know what’s working.",
  },
];
export const marketingTechStack = ["Google Analytics", "Google Ads", "Meta Ads Manager", "SEMrush", "HubSpot", "Mailchimp", "Hootsuite", "Yoast SEO", "LinkedIn Campaign Manager"];

export const marketingTechIcons = {
  "Google Analytics": "images/icons/GoogleAnalytics.webp ",
  "Google Ads": "images/icons/GoogleAds.webp",
  "Meta Ads Manager": "images/icons/meta.webp",
  SEMrush: "images/icons/semrush.webp",
  HubSpot: "images/icons/hubspot.webp",
  Mailchimp: "images/icons/mailchimp.webp",
  Hootsuite: "images/icons/hootsuite.webp",
  "Yoast SEO": "images/icons/yoast.webp",
  "LinkedIn Campaign Manager": "images/icons/linkedin.webp",
};

export const digitalSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Digital Marketing Solutions for Every Business Need",
  buildCards: [
    {
      title: "SEO Marketing Solutions",
      desc: "Improve search rankings and grow organic website traffic with strategic SEO services.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Social Media Marketing",
      desc: "Build brand awareness and audience engagement across major social platforms.",
      icon: LuBuilding2,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Performance Marketing Services",
      desc: "Run conversion-focused paid advertising campaigns for better ROI and lead generation.",
      icon: LuShoppingBag,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Email Marketing Solutions",
      desc: "Automate customer engagement with personalized email marketing campaigns.",
      icon: LuClock,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Web3 Marketing Solutions",
      desc: "Grow active Web3 communities with targeted engagement and promotion strategies.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Custom Digital Marketing Solutions",
      desc: "Tailored digital marketing strategies designed for unique business goals.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Proven Digital Marketing Process",
  processTitle: "Our Strategic Digital Marketing Approach",
  processSteps: [
    {
      step: "01",
      title: " Research & Discovery",
      description: "We understand your business goals, target audience, and marketing requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "We create a data-driven digital marketing roadmap focused on growth and conversions.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Content & Creative Planning",
      description: "We develop engaging content and campaign creatives tailored for your audience.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: " Campaign Execution",
      description: "We launch SEO, social media, PPC, and digital marketing campaigns across platforms.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Performance Optimization",
      description: "We monitor campaign performance and optimize strategies for better ROI and engagement.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Reporting & Ongoing Support",
      description: "We provide transparent reporting, insights, and continuous marketing support.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "Why Choose Our Mobile App Development Services?",
  benefitsTitle: "Why Businesses Choose Digital Marketing Services",
  benefits: [
    "Improved Online Visibility",
    "Targeted Audience Reach",
    "Data-Driven Marketing Strategies",
    "Higher Lead Generation",
    "Better Brand Engagement",
    "Measurable Marketing Results",
    "Cost-Effective Digital Growth",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const digitalPortfolioData = {
  subtitle: "OUR WORK",
  title: "Digital Project We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};

export const digitalMarketingAboutData = [
  {
    title: "Result-Driven Digital Marketing for Business Growth",
    content: (
      <>
        Digital marketing has become essential for businesses looking to improve online visibility, generate quality leads, and build stronger customer relationships. Our{" "}
        <b className="text-text-primary font-semibold">digital marketing services</b> focus on SEO, paid advertising, content strategy, and social media growth to help businesses
        create a consistent and scalable online presence. We develop performance-focused campaigns designed to improve traffic, engagement, and long-term business growth across
        multiple digital channels.
      </>
    ),
  },

  {
    title: "Strategic Digital Marketing Solutions",
    content: (
      <>
        Every business has unique marketing goals, which is why customized digital strategies play an important role in achieving sustainable growth. As an experienced{" "}
        <b className="text-text-primary font-semibold">seo services company</b>, we help businesses improve search visibility, strengthen website authority, and increase organic
        traffic through technical SEO, keyword strategy, and content optimization. Our team also uses{" "}
        <a href="https://tychotechnologies.com/growth-analytics-ai-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          advanced AI analytics services
        </a>{" "}
        to track audience behavior, campaign performance, and customer engagement for data-driven marketing decisions.
      </>
    ),
  },

  {
    title: "Content Marketing & Audience Engagement",
    content: (
      <>
        High-quality content is one of the most important factors for improving online engagement and brand credibility. Businesses using our{" "}
        <a href="https://tychotechnologies.com/seo-content-strategy-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          social media marketing services
        </a>{" "}
        can strengthen audience interaction, improve communication, and increase customer retention across major social platforms. Our{" "}
        <b className="text-text-primary font-semibold">seo content marketing services</b> focus on creating search-friendly and user-focused content that improves discoverability
        while supporting long-term organic growth and stronger brand positioning.
      </>
    ),
  },

  {
    title: "Scalable Digital Marketing Services in India",
    content: (
      <>
        Businesses across healthcare, education, retail, technology, and finance industries continue to invest in scalable digital growth strategies to stay competitive online. As
        a trusted <b className="text-text-primary font-semibold">digital marketing company in india</b>, we help brands improve online reach, customer acquisition, and digital
        engagement with performance-focused marketing solutions. Our <b className="text-text-primary font-semibold">online marketing services india</b> are designed to support
        sustainable business growth through SEO, paid advertising, analytics, and conversion-focused digital campaigns backed by continuous optimization and strategic planning.
      </>
    ),
  },
];
